import React, { useCallback } from 'react';

import { useHistory } from 'react-router-dom';

import ContactUsLink from '@src/components/ContactUsLink';

import styles from './error.scss';

import bootstrap from '@src/css/bootstrap.scss';
import ml from '@src/css/metlife_css/buttons.scss';

const Error500 = () => {
    const history = useHistory();

    const handleBackClick = useCallback(() => {
        history.goBack();
    }, [history]);

    return (
        <div id="home" className={`col-12 ${styles.error_page}`}>
            <div className={bootstrap.container}>
                <div className={bootstrap.row}>
                    <div className={`${bootstrap.col} ${bootstrap['text-center']}`}>
                        <div className="error-container">
                            <img src="/img/icons/stop-watch-icon.svg" alt="A Stop watch " />
                            <h1>We&#39;re Sorry</h1>
                            <h2>The system has timed out due to a technical error.</h2>
                            <p><a className={ml['ml-link']} onClick={handleBackClick}>Go back to a previous page </a> or <ContactUsLink>contact us</ContactUsLink> for help.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Error500;
